import { createAction, props } from '@ngrx/store';
import { ColumnGroups } from './interfaces/column.interface';

export const GENERAL_FEATURE_NAME = 'general';

export const getColumnGroups = createAction(
  `[${GENERAL_FEATURE_NAME}] Get column groups`,
);

export const getColumnGroupsSuccess = createAction(
  `[${GENERAL_FEATURE_NAME}] Get column groups success`,
  props<{ columnGroups: ColumnGroups }>(),
);

export const getColumnGroupsFailure = createAction(
  `[${GENERAL_FEATURE_NAME}] Get column groups failure`,
);

export const setColumnGroups = createAction(
  `[${GENERAL_FEATURE_NAME}] Set column groups`,
  props<{ columnGroups: ColumnGroups }>(),
);

export const setLang = createAction(
  `[${GENERAL_FEATURE_NAME}] Set Lang`,
  props<{ lang: string }>(),
);

export const setLangSuccess = createAction(
  `[${GENERAL_FEATURE_NAME}] Set Lang success`,
);

export const clearStore = createAction(
  `[${GENERAL_FEATURE_NAME}] Clear store`,
);
